import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React from "react";
import styles from "../utils/styles.css";
import DesignerCard from "../utils/DesignerCard.js";
export var FeaturedDesigners = function FeaturedDesigners(_ref) {
  var featuredDesigners = _ref.featuredDesigners;
  var desktopProps = {
    containerClassName: "designer-card-image-container",
    imageClassName: "designer-card-image",
    width: 473,
    height: 246,
    show_spinner: false,
    lazy: false,
    smartCrop: false
  };
  var mobileProps = {
    containerClassName: "designer-card-image-container",
    imageClassName: "designer-card-image",
    width: 350,
    height: 182,
    show_spinner: false,
    lazy: false,
    smartCrop: false
  };
  var handleClick = function handleClick(designer, index) {
    analytics.track("Click-through to Gallery", {
      designerCards: _mapInstanceProperty(featuredDesigners).call(featuredDesigners, function (designer) {
        return designer.attributes.name;
      }).join(","),
      designerId: designer.attributes.id,
      designerName: designer.attributes.name,
      designerUrl: designer.attributes.url,
      platform: window.innerWidth > 767 ? "desktop web" : "mobile web",
      position: index + 1,
      product: "fashion",
      productType: "Wedding Gowns",
      source: "featured designer card"
    });
  };
  var imageProps = window.innerWidth > 767 ? desktopProps : mobileProps;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.weddingDressDesignerCards
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.centeredBackgroundBorderSeparator)
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.featuredDesignerHeader, " ").concat(styles.centeredBackgroundBorderSeparatorContent)
  }, "FEATURED DESIGNERS")), /*#__PURE__*/React.createElement("div", {
    className: styles.weddingDressDesignerCardWrapper
  }, _mapInstanceProperty(featuredDesigners).call(featuredDesigners, function (designer, index) {
    return /*#__PURE__*/React.createElement(DesignerCard, {
      designer: designer,
      index: index,
      imageProps: imageProps,
      onClick: function onClick() {
        return handleClick(designer, index);
      },
      key: designer.attributes.imageUuid || index
    });
  })));
};
export default FeaturedDesigners;